import { numberFormatter } from 'components/AgGrid/utils';
import type { CatalogUerBaseCostTotalItem, CollectionUerBaseCostTotalItem } from 'gql/graphql';

import type { ColDef } from 'ag-grid-community';
import type { CellClassParams } from 'ag-grid-community/dist/types/core/entities/colDef';
import cn from 'classnames';
import { useMemo } from 'react';

const cellClass = (cellClassParams: CellClassParams<CatalogUerBaseCostTotalItem | CollectionUerBaseCostTotalItem>) => {
    const { isHeadLine, hasIndent } = cellClassParams.data || {};

    return cn({
        'is-ordinary-row': true,
        'is-headline': !!isHeadLine,
        'has-indent': cellClassParams.colDef.field === 'name' && !!hasIndent,
        'is-right-aligned': cellClassParams.colDef.field === 'value',
    });
};

export const useUERBaseCostTotalsColumns = () =>
    useMemo<ColDef<CatalogUerBaseCostTotalItem | CollectionUerBaseCostTotalItem>[]>(
        () => [
            {
                field: 'name',
                headerName: 'Наименование',
                flex: 1,
                cellClass,
            },
            {
                field: 'value',
                headerName: 'Стоимость единицы в базисном уровне цен',
                width: 200,
                valueFormatter: numberFormatter(2),
                cellClass,
            },
        ],
        [],
    );
